// ============================================================
// Roller ve yetkilendirme (§2)
//
// Ayarlar ekranı dört rol tanımlıyordu ama karşılığı yoktu:
// uygulamayı açan herkes her şeyi görüyor ve değiştirebiliyordu.
//
// Buradaki rol ve yetki tanımı, firestore.rules ile AYNI adlandırmayı
// kullanır (yonetici / mudur / egitmen / veli). Arayüz yetkisi bir
// kolaylıktır — asıl kapı sunucudaki kuraldır; ikisi ayrışırsa
// kullanıcı butonu görür ama işlem reddedilir.
// ============================================================

import { kiraciBul, subeler, tumKiracilar } from "./context.js";
import { modulAcik } from "./billing.js";
import { kiraciSec, state } from "../state.js";
import { aktoruAyarla } from "../repo/index.js";

export const ROLLER = {
  // Sistem operatörü = ürünü işleten taraf. Kiracıların ÜSTÜNDEDİR;
  // tek rol budur ve tüm kiracıları görebilir.
  sistem:   { label: "Sistem Operatörü", tumKiracilar: true, tumSubeler: true, personel: false },
  yonetici: { label: "Kurum Yöneticisi", tumKiracilar: false, tumSubeler: true,  personel: true },
  mudur:    { label: "Şube Müdürü",      tumKiracilar: false, tumSubeler: false, personel: true },
  egitmen:  { label: "Öğretmen",         tumKiracilar: false, tumSubeler: false, personel: true },
  mutfak:   { label: "Mutfak",           tumKiracilar: false, tumSubeler: false, personel: true },
  servis:   { label: "Servis",           tumKiracilar: false, tumSubeler: false, personel: true },
  veli:     { label: "Veli",             tumKiracilar: false, tumSubeler: false, personel: false },
};

/**
 * Görünüm erişimi. Listede olmayan rol o ekranı hiç görmez —
 * menüde de çıkmaz, doğrudan adrese gidilse de açılmaz.
 */
// Sistem operatörü yalnızca kendi panelinde. Kurum ekranlarının
// hiçbirinde yok ve bu bilinçli: uygulama sahibinin müşterinin çocuk
// adına, sağlık kaydına veya veli mesajına erişmesi için meşru bir
// gerekçe yok. Firestore kuralları da aynı sınırı çiziyor (kiraciDa
// artık sistemi içermiyor) — arayüzü açsak bile veri gelmezdi.
export const GORUNUM_YETKISI = {
  sistem:      ["sistem"],
  abonelik:    ["yonetici"],
  panel:       ["yonetici", "mudur", "egitmen"],
  yoklama:     ["yonetici", "mudur", "egitmen"],
  rapor:       ["yonetici", "mudur", "egitmen"],
  menu:        ["yonetici", "mudur", "egitmen", "mutfak", "veli"],
  saglik:      ["yonetici", "mudur", "egitmen", "mutfak"],
  ogrenciler:  ["yonetici", "mudur", "egitmen"],
  siniflar:    ["yonetici", "mudur", "egitmen"],
  personel:    ["yonetici", "mudur"],
  mesajlar:    ["yonetici", "mudur", "egitmen", "veli"],
  odemeler:    ["yonetici", "mudur"],
  finans:      ["yonetici", "mudur"],
  raporlar:    ["yonetici", "mudur"],
  basvurular:  ["yonetici", "mudur"],
  etkinlikler: ["yonetici", "mudur", "egitmen", "veli"],
  ayarlar:     ["yonetici", "mudur"],

  // Veli portalı
  bugun:       ["veli"],
  odemelerim:  ["veli"],
};

/**
 * Eylem yetkileri. Görünümü görmek ile içinde değişiklik yapmak
 * ayrı şeylerdir — öğretmen ödemeleri hiç görmez, mutfak menüyü
 * görür ama öğrenci dosyasını açamaz.
 */
export const EYLEM_YETKISI = {
  yoklamaYaz:      ["yonetici", "mudur", "egitmen"],
  cikisKaydet:     ["yonetici", "mudur", "egitmen"],
  ogrenciDuzenle:  ["yonetici", "mudur"],
  ogrenciDosyaGor: ["yonetici", "mudur", "egitmen"],
  personelDuzenle: ["yonetici", "mudur"],
  odemeGor:        ["yonetici", "mudur"],
  odemeDuzenle:    ["yonetici", "mudur"],
  tarifeDuzenle:   ["yonetici"],
  ilacUygula:      ["yonetici", "mudur", "egitmen"],
  olayKaydet:      ["yonetici", "mudur", "egitmen"],
  mesajYaz:        ["yonetici", "mudur", "egitmen", "veli"],
  basvuruYonet:    ["yonetici", "mudur"],
  denetimIziGor:   ["yonetici", "mudur"],
  kiraciYonet:     ["sistem"],
  abonelikGor:     ["sistem", "yonetici"],
  planDegistir:    ["sistem"],
  maasGor:         ["yonetici", "mudur"],
  bordroOnayla:    ["yonetici"],
  avansOnayla:     ["yonetici", "mudur"],
  giderKaydet:     ["yonetici", "mudur", "egitmen", "mutfak"],
  giderOnayla:     ["yonetici", "mudur"],
  subeDegistir:    ["yonetici"],
  fotografYukle:   ["yonetici", "mudur"],
};

// ---------- Oturum ----------

let oturumKullanici = null;

/**
 * Oturum nesnesi — firestore.rules'daki custom claim ile aynı şekil.
 *   { uid, name, role, branches[], classes[], children[] }
 */
export const oturum = () => oturumKullanici;
export const rol = () => oturumKullanici?.role ?? null;
export const girisYapildiMi = () => oturumKullanici != null;

export function girisYap(kullanici) {
  oturumKullanici = {
    tenantId: null,
    branches: [],
    classes: [],
    children: [],
    ...kullanici,
  };

  // Kullanıcı kendi kiracısına sabitlenir. Sistem operatörü hariç
  // kimse başka kiracıya geçemez — state buradan kuruluyor ki
  // arayüzün herhangi bir yeri yanlış kiracıyı gösteremesin.
  if (oturumKullanici.tenantId && oturumKullanici.tenantId !== state.tenantId) {
    kiraciSec(oturumKullanici.tenantId);
  }
  // Denetim izi kaydı bu kimlikle damgalanır.
  aktoruAyarla({
    uid: oturumKullanici.uid,
    name: oturumKullanici.name,
    role: oturumKullanici.role,
  });
  return oturumKullanici;
}

export function cikisYap() {
  oturumKullanici = null;
}

// ---------- Yetki kontrolü ----------

/**
 * Ekran açılabilir mi?
 *
 * İKİ ayrı kapı vardır ve ikisi de geçilmelidir:
 *   1. Rol   — kullanıcının yapmaya yetkili olduğu şey (güvenlik)
 *   2. Plan  — kiracının satın aldığı şey (ticari)
 *
 * Sistem operatörü plan kapısına tabi değildir; kiracının ne satın
 * aldığından bağımsız olarak destek verebilmelidir.
 */
export const gorebilir = viewId => {
  if (!rol()) return false;
  if (!(GORUNUM_YETKISI[viewId] ?? []).includes(rol())) return false;
  if (rol() === "sistem") return true;
  if (SISTEM_GORUNUMLERI.has(viewId)) return true;
  return modulAcik(viewId);
};

// Plan kapsamı dışında kalan, her kiracıda bulunan ekranlar.
const SISTEM_GORUNUMLERI = new Set(["abonelik", "sistem"]);

export const yapabilir = eylem =>
  Boolean(rol()) && (EYLEM_YETKISI[eylem] ?? []).includes(rol());

// ---------- Kiracı kapsamı ----------

/** Kullanıcının erişebildiği kiracılar. Sistem operatörü hariç tek kiracı. */
export function erisilebilirKiracilar() {
  const o = oturum();
  if (!o) return [];
  if (ROLLER[o.role]?.tumKiracilar) return tumKiracilar();
  const k = kiraciBul(o.tenantId);
  return k ? [k] : [];
}

export const kiraciyaErisebilir = tenantId =>
  erisilebilirKiracilar().some(t => t.id === tenantId);

/** Kiracı değiştirme — yalnızca sistem operatörü. */
export function kiraciDegistir(tenantId) {
  if (!kiraciyaErisebilir(tenantId)) return false;
  return kiraciSec(tenantId);
}

// ---------- Şube kapsamı ----------

/**
 * Kullanıcının erişebildiği şubeler.
 * Aday küme HER ZAMAN kullanıcının kendi kiracısının şubeleridir —
 * "tüm şubeler" yetkisi bile kiracı sınırını aşamaz.
 */
export function erisilebilirSubeler() {
  const o = oturum();
  if (!o) return [];
  const aday = ROLLER[o.role]?.tumKiracilar ? subeler(state.tenantId) : subeler(o.tenantId);
  if (ROLLER[o.role]?.tumSubeler) return aday;
  return aday.filter(b => o.branches.includes(b.id));
}

export const subeyeErisebilir = branchId =>
  erisilebilirSubeler().some(b => b.id === branchId);

/** Eğitmen yalnızca kendi sınıfına yazabilir. */
export function sinifaYazabilir(classId) {
  const o = oturum();
  if (!o) return false;
  if (o.role === "egitmen") return o.classes.includes(classId);
  return yapabilir("yoklamaYaz");
}

/** Velinin çocuğu mu? */
export const kendiCocugu = studentId =>
  rol() === "veli" && (oturum()?.children ?? []).includes(studentId);

/** Bu öğrencinin dosyası bu kullanıcıya açık mı? */
export function ogrenciyiGorebilir(student) {
  if (kendiCocugu(student.id)) return true;
  if (!yapabilir("ogrenciDosyaGor")) return false;
  const o = oturum();
  if (o.role === "egitmen") return o.classes.includes(student.classId);
  return true;
}

/** Velinin çocukları. */
export function cocuklarim() {
  const o = oturum();
  if (o?.role !== "veli") return [];
  return subeler(o.tenantId)
    .flatMap(b => b.students.map(s => ({ ...s, branchId: b.id })))
    .filter(s => o.children.includes(s.id));
}

// ---------- Demo kullanıcıları ----------
//
// Gerçek Firebase Auth kurulana kadar rol denemesi bu listeden yapılır.
// .env yapılandırıldığında girisYap() Auth'tan gelen custom claim ile
// çağrılır; aşağıdaki liste yalnızca demo/satış sunumu içindir.

export function demoKullanicilar() {
  const liste = [
    {
      uid: "demo-sistem",
      name: "MinikPanel Operasyon",
      role: "sistem",
      title: `${tumKiracilar().length} kiracı · tüm sistem`,
      tenantId: null,
      branches: [],
      classes: [],
      children: [],
    },
  ];

  for (const kiraci of tumKiracilar()) {
    const sube = kiraci.branches[0];
    if (!sube) continue;

    liste.push({
      uid: `${kiraci.id}-yonetici`,
      name: kiraci.contact.name,
      role: "yonetici",
      title: `${kiraci.name} · tüm şubeler`,
      tenantId: kiraci.id,
      branches: kiraci.branches.map(b => b.id),
      classes: [],
      children: [],
    });

    const ogretmen = sube.staff.find(x => x.role === "Sınıf Öğretmeni");
    if (ogretmen) {
      liste.push({
        uid: `${kiraci.id}-${ogretmen.id}`,
        name: ogretmen.name,
        role: "egitmen",
        title: `${kiraci.name} · ${sube.classes.find(c => c.id === ogretmen.classId)?.name ?? sube.name}`,
        tenantId: kiraci.id,
        branches: [sube.id],
        classes: [ogretmen.classId].filter(Boolean),
        children: [],
      });
    }

    // Kardeşi olan bir veli varsa onu seç — çok çocuklu görünüm daha bilgilendirici.
    const veliAdlari = sube.students.map(x => x.parent);
    const cokCocuklu = veliAdlari.find((ad, i) => veliAdlari.indexOf(ad) !== i);
    const veliAdi = cokCocuklu ?? sube.students[0]?.parent;
    const cocuklar = sube.students.filter(x => x.parent === veliAdi);

    if (veliAdi) {
      liste.push({
        uid: `${kiraci.id}-veli`,
        name: veliAdi,
        role: "veli",
        title: `${kiraci.name} · ${cocuklar.map(c => c.name.split(" ")[0]).join(", ")} velisi`,
        tenantId: kiraci.id,
        branches: [sube.id],
        classes: [],
        children: cocuklar.map(c => c.id),
      });
    }
  }

  // Şube müdürü ve mutfak yalnızca ilk kiracıda — rol çeşidini göstermek için.
  const ilk = tumKiracilar()[0];
  const ilkSube = ilk?.branches[0];
  if (ilkSube) {
    const asci = ilkSube.staff.find(x => /aşçı|mutfak/i.test(x.role));
    liste.splice(2, 0, {
      uid: `${ilk.id}-mudur`,
      name: "Nilgün Aksoy",
      role: "mudur",
      title: `${ilk.name} · ${ilkSube.name}`,
      tenantId: ilk.id,
      branches: [ilkSube.id],
      classes: [],
      children: [],
    });
    if (asci) {
      liste.splice(4, 0, {
        uid: `${ilk.id}-${asci.id}`,
        name: asci.name,
        role: "mutfak",
        title: `${ilk.name} · ${asci.role}`,
        tenantId: ilk.id,
        branches: [ilkSube.id],
        classes: [],
        children: [],
      });
    }
  }

  return liste;
}

/** Açılış kullanıcısı — demo kurulumda kurum yöneticisi. */
export const varsayilanKullanici = () =>
  demoKullanicilar().find(u => u.role === "yonetici") ?? demoKullanicilar()[0];
